import _ from 'lodash';

/* eslint-disable */
// Init Drift via the official
export const init = (user) => {
  // Do not init in development
  if (process.env.NODE_ENV === 'development') {
    return;
  }

  // Copied from the original recommended integration, that's why it looks so ES5.
  var t = (window.driftt = window.drift = window.driftt || []);
  if (!t.init) {
    if (t.invoked)
      return; // Already initiated. Do not initiate twice.
    (t.invoked = !0),
      (t.methods = [
        'identify',
        'config',
        'track',
        'reset',
        'debug',
        'show',
        'ping',
        'page',
        'hide',
        'off',
        'on',
      ]),
      (t.factory = function(e) {
        return function() {
          var n = Array.prototype.slice.call(arguments);
          return n.unshift(e), t.push(n), t;
        };
      }),
      t.methods.forEach(function(e) {
        t[e] = t.factory(e);
      }),
      (t.load = function(t) {
        var e = 3e5,
          n = Math.ceil(new Date() / e) * e,
          o = document.createElement('script');
        (o.type = 'text/javascript'),
          (o.async = !0),
          (o.crossorigin = 'anonymous'),
          (o.src = 'https://js.driftt.com/include/' + n + '/' + t + '.js');
        var i = document.getElementsByTagName('script')[0];
        i.parentNode.insertBefore(o, i);
      });
  }
  window.drift.SNIPPET_VERSION = '0.3.1';
  window.drift.load('3kxxfgr9rufu');

  // Identify the currently logged in user, if it exists.
  if (user) {
    window.drift.identify(user._id, {
      // Nested properties and methods of the user were breaking it.
      // That's why - cherry pick the ones which I need the most
      ..._.pick(user, 'email', 'lang', 'name', 'urls', 'workspace', '_id'),
      avatarUrl: user.getBigAvatarUrl(),
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/drift.js